module.exports = __webpack_public_path__ + "img/img1.5144f79a.png";